<script lang="ts">
  import { cn } from '@/lib/utils';

  export let title: string;
  /** Font Awesome icon for the title, e.g. `fa-clock`. */
  export let icon: string = '';
  /** What the card is coloured by: its border, and its icon. A colour the app already uses for the same thing where it has one. */
  export let color: string = '';
  /** Label for the button that opens the `details` slot; without a `details` slot there is no button. */
  export let detailsLabel: string = 'Details';
  /** The figures sit in one row: one column each. */
  export let columns: string = 'repeat(4, minmax(0, 1fr))';

  let showDetails = false;

  /** The colour blended towards white (`#rrggbb` in, `rgb()` out), for a border that colours a card without shouting. */
  function soften(hex: string, share = 0.55): string {
    const value = hex.replace('#', '');
    if (!/^[0-9a-fA-F]{6}$/.test(value)) return hex;
    const [r, g, b] = [0, 2, 4].map((at) => parseInt(value.slice(at, at + 2), 16));
    const blend = (channel: number) => Math.round(channel * share + 255 * (1 - share));
    return `rgb(${blend(r)}, ${blend(g)}, ${blend(b)})`;
  }
</script>

<!-- The border is the colour softened, so a row of cards reads as coloured without shouting. (No `border-border` class then: utilities are !important here and would win over the inline colour.) -->
<section
  class={cn('rounded-lg border border-solid bg-white p-3 flex flex-col gap-2 min-w-0', !color && 'border-border')}
  style={color ? `border-color: ${soften(color)}` : ''}
>
  <h3 class="text-sm font-medium tracking-wide text-muted-foreground m-0 whitespace-nowrap flex items-center gap-1.5">
    {#if icon}<i class="fa-solid {icon} text-xs" style={color ? `color: ${color}` : ''} aria-hidden="true"></i>{/if}
    {title}
  </h3>
  <dl class="grid gap-x-2 m-0" style="grid-template-columns: {columns}">
    <slot />
  </dl>
  {#if $$slots.details}
    <button
      type="button"
      class="self-start text-xs text-muted-foreground hover:text-foreground bg-transparent border-0 p-0 cursor-pointer whitespace-nowrap"
      aria-expanded={showDetails}
      on:click={() => (showDetails = !showDetails)}
    >
      <i class="fa-solid {showDetails ? 'fa-chevron-up' : 'fa-chevron-down'} text-[10px] mr-1" aria-hidden="true"></i>{showDetails ? 'Hide' : 'Show'} {detailsLabel}
    </button>
    {#if showDetails}
      <slot name="details" {columns} />
    {/if}
  {/if}
</section>
